export default "__VITE_ASSET__0d08ec15__"